import React, { Component } from 'react';
import InfoCircle from '../components/css/dark/img//theme-images/info-circle-solid.svg';
const { AbortController } = window;

class Claim extends Component {
    constructor(props) {
        super(props);
        this.state = {
            PD: '-',
            Rev: '-',
            NC: '-',
            CC: '-',
            loader: false,
            userdata: JSON.parse(localStorage.getItem('user')),
        };
        this.abortController = null;
        this.debounceTimer = null;

    }
    componentDidUpdate(prevProp) {
        if (prevProp.data.RequestJson != this.props.data.RequestJson && this.props.data.type == "Claim") {
            this.fetchData_locally();
        }
    }
    componentDidMount() {
        if (this.props.data.type == "Claim") {
            this.fetchData_locally();
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    componentWillUnmount() {
        if (this.abortController) {
            this.abortController.abort();
        }
    }

    fetchData_locally() {
        // Cancel any previous pending request
        if (this.abortController) {
            this.abortController.abort();
        }
        // Create a new AbortController for this request
        this.abortController = new AbortController();
        const signal = this.abortController.signal;


        this.setState({
            IsDataLoaded: false,
            loader: true
        });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'requestHeader': this.props.data.RequestJson1, 'X-Browser-Url': window.location.href },
            body: this.props.data.RequestJson,
            signal //  attach abort signal here
        };
        return fetch(this.props.data.url, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    this.setState({ loader: false, PD: apidata[0].legend[0].legendValue, Rev: apidata[0].legend[1].legendValue, NC: apidata[0].legend[2].legendValue, CC: apidata[0].legend[3].legendValue });
                }
                catch (error) {
                }
                if (!signal.aborted) {
                    this.setState({
                        IsDataLoaded: true
                    });
                }
            }).catch(err => {
                if (err.name === "AbortError") {
                    // Expected cancel, just ignore
                    //console.log("Fetch request aborted");
                    return;
                }
                // Unexpected error
                //console.error("Fetch error:", err);
                this.setState({
                    IsDataLoaded: true
                });
            });
    }

    render() {
        let Reversal_Rate = 0.00;
        let Compensability_Rate = 0.00;
        try {
            Reversal_Rate = ((parseFloat(this.state.Rev.replace(',', '')) /  parseFloat(this.state.PD.replace(',', ''))) * 100).toFixed(2);
            Compensability_Rate = ((1 - (parseFloat(this.state.CC.replace(',', '')) / parseFloat(this.state.NC.replace(',', '')))) * 100).toFixed(2);
        }
        catch (err) { }
        return (
            <div className="claimOverview">
                <div className="claimSection">

                    <div className="paid">
                        {
                            this.state.loader ?
                                <div className="loader-section"><div className="theme-loader"></div></div> : null
                        }
                        {/*<div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>*/}
                        <span className="small">Total Claims</span>
                        <span>{this.state.PD}</span>
                    </div>

                    <div className="paid">
                        {
                            this.state.loader ?
                                <div className="loader-section"><div className="theme-loader"></div></div> : null
                        }
                        {/*<div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>*/}
                        <span className="small">Reversed Claims</span>
                        <span>{this.state.Rev}</span>
                    </div>

                    <div className="paid">
                        {
                            this.state.loader ?
                                <div className="loader-section"><div className="theme-loader"></div></div> : null
                        }
                        {/*<div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>*/}
                        <span className="small">Net Claims</span>
                        <span>{this.state.NC}</span>
                    </div>

                    <div className="paid last">
                        {
                            this.state.loader ?
                                <div className="loader-section"><div className="theme-loader"></div></div> : null
                        }
                        {/* <div className="tool-tip-section">
                        <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                        <span className="toolTipContent">HD claims only</span>
                    </div>*/}
                        <span className="small">Paid Claims</span>
                        <span>{this.state.CC}</span>
                    </div>


                </div>
                {
                    (this.state.userdata.wholesaler_Id == 255 && this.state.userdata.userrole == 'Wholesaler') || (this.state.userdata.wholesaler_Id == 294 && this.state.userdata.userrole == 'Wholesaler') ?
                        <div className="claimSection bottom less-than">
                            <div className="paid">
                                {
                                    this.state.loader ?
                                        <div className="loader-section"><div className="theme-loader"></div></div> : null
                                }
                                <span className="small">Reversal Rate(%)</span>
                                <span>{Reversal_Rate}</span>
                            </div>
                            <div className="paid">
                                {
                                    this.state.loader ?
                                        <div className="loader-section"><div className="theme-loader"></div></div> : null
                                }
                                <span className="small">Compensability Rate (%)</span>
                                <span>{Compensability_Rate}</span>
                            </div>
                            <div className="paid not-visible">&nbsp;</div>
                            <div className="paid not-visible last">&nbsp;</div>
                        </div> : null
                }
            </div>
        )
    }
}
export default Claim;